import InputBase from './Input';
export * from './Input';
export const Input = InputBase;

export default InputBase;
